export default "__VITE_ASSET__WOSWBrPk__"